import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";

// extract the type from the array of that type
type Unpack<T> = T extends (infer U)[] ? U : T;

type TParams1 = {
  originalPrice: number;
  originalPriceWithoutDiscount: number;
  unitId?: number;
};

type TParams2 = {
  specialPrices: IProduct["selling_prices"];
  quantity: number;
};

const calculatPricesForSpecialPrices =
  ({ originalPrice, originalPriceWithoutDiscount, unitId }: TParams1) =>
  ({ specialPrices, quantity }: TParams2) => {
    const sortedSpecialPrices = [...(specialPrices || [])].sort(
      (a, b) => a.price - b.price,
    );
    const matchWithRule = checkQuantityUnitRuleMatch(quantity, unitId);
    const matchedSpecialPrice = sortedSpecialPrices.find(matchWithRule);
    if (matchedSpecialPrice?.price) {
      return {
        price: matchedSpecialPrice.price,
        price_without_discount: matchedSpecialPrice.price_without_discount,
      };
    }

    return {
      price_without_discount: originalPriceWithoutDiscount,
      price: originalPrice,
    };
  };

export default calculatPricesForSpecialPrices;

const checkQuantityUnitRuleMatch =
  (quantity: number, unit_id?: number) =>
  (specialPrice: Unpack<IProduct["selling_prices"]>) => {
    const operators: Record<1, Function> = {
      "1": () => {
        if (unit_id) {
          return (
            unit_id === specialPrice.unit_id &&
            quantity >= specialPrice.quantity
          );
        }
        return quantity >= specialPrice.quantity;
      },
    };
    return operators["1"]();
  };
